import { defineManifest } from "@crialume/sdk";
import { UsersThreeIcon } from "@crialume/ui/icons";

export default defineManifest({
  id: "usuarios",
  version: "0.1.0",
  meta: {
    name: "Usuários",
    description: "Contas cadastradas na plataforma",
    icon: UsersThreeIcon,
    category: "core",
    order: 3,
  },
  requirements: {
    permissions: ["accounts.manage"],
  },
  nav: [{ label: "Usuários", path: "", icon: UsersThreeIcon }],
  loader: () => import("./module"),
});
